import { Helmet } from 'react-helmet-async';
import TcTable from '../../../sections/termsAndConditions/TcTable';

export default function TermsAndConditionsListPage() {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions</title>
      </Helmet>

      <TcTable />
    </>
  );
}
